import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/react/shallow';

import { useGradeFlow } from '@/states/grade-flow';
import { useInitHypertensiveForm } from '@/hooks/grade-flow/use-init-hypertensive-form';

import { Badge } from '@/components/ui/badge';

import { ReadableImages } from '../readable-images';
import { PearEyeQuestions } from './pear-eye-questions';

export function HypertensiveForm() {
  const { t } = useTranslation();
  useInitHypertensiveForm();

  const { hasLaterality } = useGradeFlow(
    useShallow((s) => ({ hasLaterality: s.isLateralityPresentOnImgs }))
  );

  if (!hasLaterality) {
    return (
      <div className="flex-1 w-full flex flex-col items-start">
        <ReadableImages size="sm" displayTitle={false} />
        <PearEyeQuestions laterality="both" />
      </div>
    );
  }

  return (
    <>
      <h2 className="mb-4 md:mb-8 font-bold">
        {t('grade-hypertensive-retinopathy-questions-title')}
      </h2>

      <div className="flex-1 flex justify-between max-w-full">
        <div className="pr-4 flex flex-col items-start shrink-0 grow w-[48%]">
          <Badge color="blue" className="mb-4">
            {t('right')}
          </Badge>
          <ReadableImages filter="right" size="sm" displayTitle={false} />
          <PearEyeQuestions laterality="right" />
        </div>
        <div className="w-px bg-border" />
        <div className="pl-4 flex flex-col items-start shrink-0 grow w-[48%]">
          <Badge color="blue" className="mb-4">
            {t('left')}
          </Badge>
          <ReadableImages filter="left" size="sm" displayTitle={false} />
          <PearEyeQuestions laterality="left" />
        </div>
      </div>
    </>
  );
}
